// Every screen that lets you pick a platform reads this, so a sale can never be
// created with a value another screen's dropdown cannot render.
export const PLATFORM_OPTIONS = ['eBay', 'Discord'];

export const PLATFORM_DATA = {
    default: {
        name: 'Default',
        transactionDetails: {
            transactionFields: [
                {
                    label: 'Order Total',
                    key: 'orderTotal',
                    type: 'currency',
                    required: true
                },
                {
                    label: 'Shipping Cost',
                    key: 'shipping',
                    type: 'currency',
                    required: false
                },
                {
                    label: 'Transaction Fees',
                    key: 'transactionFee',
                    type: 'currency',
                    required: false
                }
            ]
        }
    },
    ebay: {
        name: 'eBay',
        url: 'https://www.ebay.com',
        logo: 'https://www.ebay.com/favicon.ico',
        finalValueFees: {
            basis: 'orderTotal',
            currency: 'USD',
            tiers: [
                {
                    upTo: 7500,
                    ratePercent: 13.25
                },
                {
                    over: 7500,
                    ratePercent: 2.35
                }
            ],
            perOrderFees: [
                {
                    upTo: 10,
                    fee: 0.30
                },
                {
                    over: 10,
                    fee: 0.40
                }
            ]
        },
        transactionDetails: {
            transactionFields: [
                {
                    label: 'Order Total',
                    key: 'orderTotal',
                    type: 'currency',
                    required: true
                },
                {
                    label: 'Sales Tax',
                    key: 'salesTax',
                    type: 'currency',
                    required: false
                },
                {
                    label: 'Transaction Fees',
                    key: 'transactionFee',
                    type: 'currency',
                    required: false
                },
                {
                    label: 'Shipping Cost',
                    key: 'shipping',
                    type: 'currency',
                    required: false
                }
            ]
        }
    }
};
